import React from 'react';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicAlbumEntity } from '../../types/MusicAlbumEntityTypes';
import { showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicAlbumDeleteConfirmPopup({
  musicAlbum, onDone, onCancel,
} : {
  musicAlbum: MusicAlbumEntity,
  onCancel: () => void,
  onDone: () => void,
}) {
  const { removeMusicAlbum } = React.useContext(MusicDistributionClientContext);
  const handleSubmit = () => {
    removeMusicAlbum(musicAlbum.id).then((responseData) => {
      if (responseData.result) {
        onDone();
      } else {
        showErrorFlush('入力内容に不備があります。');
      }
    });
  };
  return (
    <PopupContainer title="リリースの削除" onClose={() => { onCancel(); }}>
      <form className="cake_ajax_form">
        <div className="list__body">
          <p>このリリース（シングル・アルバム）をFrekulから削除してよろしいですか？</p>
          <p>保存されているリリース情報、曲の情報、ジャケット画像などが削除されます。</p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => { onCancel(); }}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => { handleSubmit(); }}>削除</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
